import { render, staticRenderFns } from "./ProductGridAsset.vue?vue&type=template&id=319bcd4d"
import script from "./ProductGridAsset.vue?vue&type=script&lang=js"
export * from "./ProductGridAsset.vue?vue&type=script&lang=js"
import style0 from "./ProductGridAsset.vue?vue&type=style&index=0&id=319bcd4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports